






















































































































































































import ICompany from '@/store/models/ICompany';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CompanyAdressesSelector from '@/components/selectors/Company/CompanyAdressesSelector.vue';
import CompanyContactsSelector from '@/components/selectors/Company/CompanyContactsSelector.vue';
import IListCountries from '@/store/models/IListCountries';
import IListAdressTypes from '@/store/models/IListAdressTypes';
import ICompanyAdresses from '@/store/models/ICompanyAdresses';
import ICompanyContacts from '@/store/models/ICompanyContacts';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import { EMPTY_GUID } from '@/config/constants';

@Component({
    components: {
        CompanyAdressesSelector,
        CompanyContactsSelector,
        Snackbar
    }
})
export default class CompanySelector extends Vue {
    readonly EMPTY_GUID = EMPTY_GUID;
    searchCompany: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name',
            align: 'start',
            value: 'name'
        },
        { text: 'Fiscal Identifier', value: 'fiscalIdentifier' },
        { text: 'Prefix', value: 'prefix' },
        { text: 'Phone Number', value: 'phoneNumber' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : ICompany = {
        id: "",
        name: "",
        fiscalIdentifier: "",
        idListPhonePrefix: "",
        prefix: "",
        phoneNumber: "",
        companyAdresses: [],
        companyContacts: []
    }
    defaultItem : ICompany = {
        id: "",
        name: "",
        fiscalIdentifier: "",
        idListPhonePrefix: "",
        prefix: "",
        phoneNumber: "",
        companyAdresses: [],
        companyContacts: []
    }

    @Prop({ type: Array, required: true })
    CompanyList !: ICompany[];
    @Prop({ type: Array, required: true })
    ListPhonePrefix !: IListPhonePrefix[];
     @Prop({ type: Array, required: true })
    ListCountries !: IListCountries[];
    @Prop({ type: Array, required: true })
    ListAdressTypes !: IListAdressTypes[];
    @Prop({ type: Array, required: true })
    CompanyAdressesList !: ICompanyAdresses[];
    @Prop({ type: Array, required: true })
    CompanyContactsList !: ICompanyContacts[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: String, required: true })
    IdCompany !: String;
    @Prop()
    value !: ICompany;

    selectedCompany : ICompany[] = [];
    selectedCompanyAdres : ICompanyAdresses[] = [];
    selectedCompanyContact : ICompanyContacts[] = [];
    selectedPhonePrefix: any = null;
    phonePrefixCountry : string[] = [];

    get ListPhonePrefixesSort () {
        return [...this.ListPhonePrefix].sort((a, b) => a.prefix.localeCompare(b.prefix));
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Company' : 'Edit Company'; }

    get filteredCompanyList() {
        return this.IdCompany === EMPTY_GUID
            ? this.CompanyList
            : this.CompanyList.filter(company => company.id === this.IdCompany);
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('value')
    updateSelection(newValue : ICompany | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedCompany = [];
        } else {
            this.selectedCompany = [newValue];
            this.$emit('companyChanged', this.selectedCompany[0]);
        }
    }

    ResetCompany() {
        this.$emit('resetCompany');
    }

    editCompany (item: any, dbox = true) {
        if (this.selectedCompany.length > 0) {
            this.editedIndex = this.CompanyList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selectedPhonePrefix = this.ListPhonePrefix.find(p => p.id === this.editedItem.idListPhonePrefix);
            this.dialog = true;
        }
    }

    saveCompany (company: ICompany) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.setCountryPrefix();
            if (this.editedIndex > -1 || this.selectedCompany[0]) {
                this.close();
                this.$emit('editCompany', this.editedItem);
                Object.assign(this.CompanyList[this.editedIndex], this.editedItem);
            } else {
                this.$emit('saveCompany', this.editedItem);
            }
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteCompany (company: ICompany) {
        if (this.selectedCompany.length > 0) {
            this.$emit('deleteCompany', company);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    setCountryPrefix() {
        if (this.selectedPhonePrefix) {
            let phonePrefix: IListPhonePrefix = this.ListPhonePrefix.find(p => p.country === this.selectedPhonePrefix.country)!;
            if (phonePrefix) {
                this.editedItem.idListPhonePrefix = phonePrefix.id;
                this.editedItem.prefix = phonePrefix.prefix;
            }
        }
    }

    select(item : ICompany) : void {
        let index : number = this.selectedCompany.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedCompany = [item];
            this.$emit('input', item);
        } else {
            let company = this.selectedCompany.find(w => w.id === item.id);
            if (!company) {
                this.selectedCompany = [];
                this.$emit('input', null);
            }
        }
    }

    saveCompanyAdress(item : any) : void {
        this.$emit('saveCompanyAdress', item);
    }

    editCompanyAdress(item : any) : void {
        this.$emit('editCompanyAdress', item);
    }
    
    deleteCompanyAdress(item : any) : void {
        this.$emit('deleteCompanyAdress', item);
    }

    saveCompanyContact(item : any) : void {
        this.$emit('saveCompanyContact', item);
    }

    editCompanyContact(item : any) : void {
        this.$emit('editCompanyContact', item);
    }
    
    deleteCompanyContact(item : any) : void {
        this.$emit('deleteCompanyContact', item);
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
